import { Button, Layout, notification, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { Target } from "react-feather";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";
import { TargetGrid } from "./TargetGrid";
import TargetStore from "../productiontarget/store/TargetStore";
import { TargetUploadDialog } from "./TargetUploadDialog";
import { ProgressIndicator, Label } from "@fluentui/react";
import { MonthTargetForm } from "./MonthTargetForm";
import { Pivot, PivotItem } from "@fluentui/react/lib/Pivot";
import { Equity } from "./Equity";
import { Fiscalization } from "./Fiscalization";
import { FiscalizationUploadDialog } from "./FiscalizationUploadDialog";
import { FiscalizationEditDialog } from "./FiscalizationEditDialog";

const { Content } = Layout;
const targetstore = createContext(TargetStore);
export const NaocProductionTarget = observer(() => {
  const targetStore = useContext(targetstore);
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #2196f3",
      }}
    >
      <Content>
        <Pivot aria-label="Basic Pivot Example">
          <PivotItem
            headerText="Production and Evacuation Targets"
            headerButtonProps={{
              "data-order": 1,
            }}
          >
            <div className="ms-Grid" dir="ltr" style={{ padding: "10px" }}>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm6">
                  <SubPageHeaderTitle
                    title={`${targetStore.mainStore.assetContextName}-OANDO Poduction and Evacuation Targets for ${targetStore.targetYear}`}
                  />
                </div>
                <div
                  className={`ms-Grid-col ${
                    targetStore.importHasRows && targetStore.hasImported
                  }?'ms-sm4':'ms-sm6'`}
                >
                  <div style={{ textAlign: "right" }}>
                    <Tooltip
                      title={`click to download an excel template for ${targetStore.mainStore.assetContextName} Assets  Production and Evaculation targets.`}
                    >
                      <Button
                        type="link"
                        onClick={async () => {
                          try {
                            targetStore.isDownloadingTemplate = true;
                            await targetStore.downloadTemplate();
                          } catch (error) {
                            notification.error({
                              message: "SPARS Feedback",
                              description: `download failed,${error.message}`,
                            });
                          } finally {
                            targetStore.isDownloadingTemplate = false;
                          }
                        }}
                      >
                        <span style={{ fontSize: "12px" }}>
                          {`Download standard ${targetStore.mainStore.assetContextName}-OANDO production and evacuation target `}
                          template
                        </span>
                      </Button>
                    </Tooltip>
                  </div>
                  <div className="ms-Grid-col ms-sm12">
                    {targetStore.isDownloadingTemplate && (
                      <ProgressIndicator
                        description="downloading, please wait..."
                        styles={{ root: { textAlign: "center" } }}
                      ></ProgressIndicator>
                    )}
                  </div>
                </div>

                <div
                  className="ms-Grid-col ms-sm2"
                  style={{ textAlign: "right" }}
                >
                  {targetStore.importHasRows && targetStore.hasImported && (
                    <Button
                      type="primary"
                      icon={<Target size="16" style={{ marginRight: "5px" }} />}
                      onClick={async () => {
                        try {
                          await targetStore.saveTargets();
                          notification.success({
                            message: "SPARS Feedback",
                            description: "Targets locked successfully",
                          });
                        } catch (error) {
                          notification.error({
                            key: "error",
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }
                      }}
                      loading={targetStore.isSaving}
                    >
                      Lock Targets
                    </Button>
                  )}
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <TargetGrid
                    assetName={targetStore.mainStore.assetContextName}
                  />
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <TargetUploadDialog />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <MonthTargetForm />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <Equity />
                </div>
              </div>
            </div>
          </PivotItem>
          <PivotItem headerText="Oil Production Fiscalization">
            <Fiscalization />

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <FiscalizationUploadDialog />
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                <FiscalizationEditDialog />
              </div>
            </div>
          </PivotItem>
        </Pivot>
      </Content>
    </Layout>
  );
});

